// extracted by mini-css-extract-plugin
export default {"root":"JKrMpQXQ","root__separator":"yhF8XILP","content":"TzZnFZvf"};